(() => {
  'use strict';
  const VERSION = '2026-09-14-v2-close-only';
  if (window.__SQ_EXPANDED_CLOSE_HARD_STOP_V2__ === VERSION) return;
  window.__SQ_EXPANDED_CLOSE_HARD_STOP_V2__ = VERSION;

  const MODAL = '[data-lcs-favorite-expanded]';
  const ROOT = '[data-lcs-expanded-controller],[data-lcs-favorites-page]';
  const CLOSE = '[data-lcs-expanded-close],.lcs-favorite-expanded__close,.lcs-favorite-expanded__overlay,[data-premium-expanded-close]';
  const CART_OPENERS = [
    '[data-testid="cart-drawer-trigger"]',
    '[data-cart-drawer-toggle]',
    '[data-cart-drawer-open]',
    '[aria-controls="CartDrawer"]',
    '[aria-controls="cart-drawer"]',
    '#cart-icon-bubble',
    'a[href$="/cart"]',
    'a[href*="/cart?"]',
    'button[href="/cart"]'
  ].join(',');

  let guardUntil = 0;

  const arm = (ms = 1800) => {
    guardUntil = Math.max(guardUntil, Date.now() + ms);
    window.__SQ_EXPANDED_CLOSE_GUARD_UNTIL__ = Math.max(Number(window.__SQ_EXPANDED_CLOSE_GUARD_UNTIL__ || 0), guardUntil);
    window.__SQ_EXPANDED_POINTER_CLOSE_UNTIL__ = Math.max(Number(window.__SQ_EXPANDED_POINTER_CLOSE_UNTIL__ || 0), guardUntil);
    window.__SQ_SUPPRESS_CART_OPEN_UNTIL__ = Math.max(Number(window.__SQ_SUPPRESS_CART_OPEN_UNTIL__ || 0), guardUntil);
  };

  const guarded = () => Date.now() < Math.max(guardUntil, Number(window.__SQ_SUPPRESS_CART_OPEN_UNTIL__ || 0));

  const stop = (event, prevent = false) => {
    if (prevent && event.cancelable) event.preventDefault();
    event.stopPropagation?.();
    event.stopImmediatePropagation?.();
  };

  const closeTarget = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const close = target?.closest(CLOSE);
    return close?.closest(MODAL) ? close : null;
  };

  const controllerFor = (close) => {
    const root = close?.closest(ROOT) || close?.closest(MODAL)?.closest(ROOT);
    const direct = root?.__lcsFavoritesPage || root?.__lcsExpandedController || root?.__sqExpandedController;
    if (direct?.closeExpanded) return direct;
    if (window.SQUniversalExpandedCard?.closeExpanded) return window.SQUniversalExpandedCard;
    for (const host of document.querySelectorAll(ROOT)) {
      const controller = host.__lcsFavoritesPage || host.__lcsExpandedController || host.__sqExpandedController;
      if (controller?.closeExpanded) return controller;
    }
    return null;
  };

  const fallbackClose = (close) => {
    const modal = close?.closest(MODAL);
    const root = modal?.closest(ROOT);
    if (modal instanceof HTMLElement) {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-ready', 'has-expanded-options');
    }
    root?.classList.remove('lcs-expanded-active');
    try { window.LCSExpandedModalLock?.unlock?.(); } catch (_) {}
    document.documentElement.classList.remove('lcs-expanded-solid-lock');
    document.body.classList.remove('lcs-expanded-solid-lock');
    document.documentElement.style.removeProperty('--lcs-modal-scroll-y');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.inset = '';
    document.body.style.top = '';
    document.body.style.width = '';
  };

  const closeOnly = (close) => {
    const controller = controllerFor(close);
    if (controller?.closeExpanded) {
      try { controller.closeExpanded(); }
      catch (_) { fallbackClose(close); }
    } else {
      fallbackClose(close);
    }
    try { window.SQUniversalBagCloseout?.closeout?.(); } catch (_) {}
  };

  // Keep the modal in place for the complete pointer/touch gesture. Hiding it on
  // pointerdown lets mobile browsers retarget the remaining gesture to the cart
  // icon underneath. The actual close happens only on the final click event.
  ['pointerdown','mousedown','touchstart','pointerup','mouseup','touchend'].forEach((name) => {
    window.addEventListener(name, (event) => {
      if (!closeTarget(event)) return;
      arm();
      stop(event, false);
    }, { capture: true, passive: false });
  });

  window.addEventListener('click', (event) => {
    const close = closeTarget(event);
    if (close) {
      arm();
      stop(event, true);
      closeOnly(close);
      return;
    }

    const target = event.target instanceof Element ? event.target : null;
    if (guarded() && target?.closest(CART_OPENERS)) stop(event, true);
  }, { capture: true, passive: false });

  const blockCartHandoff = (event) => {
    if (!guarded()) return;
    stop(event, true);
  };
  document.addEventListener('sq:cart:handoff', blockCartHandoff, true);
  window.addEventListener('sq:cart:handoff', blockCartHandoff, true);

  window.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const modal = document.querySelector(`${MODAL}:not([hidden])`);
    if (!(modal instanceof HTMLElement)) return;
    const close = modal.querySelector(CLOSE) || modal;
    arm();
    stop(event, true);
    closeOnly(close);
  }, true);
})();
